module.exports = __webpack_public_path__ + "static/media/sprite.d666b9f5.svg";